import {COUNTRIES_UPPERCASE} from "../../../../../../../constants/countries";

export default (country) => (COUNTRIES_UPPERCASE.find((el) => el[1] === country) || [])[0];
